// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "../../../../../../../../node_modules/re-formality/src/Formality.mjs";
import * as Formality__ReactUpdate from "../../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.mjs";
import * as FareEstimateResultStoreEn$PorterinFeature from "../../../../core/constants/FareEstimateResultStoreEn.mjs";
import * as FareEstimateResultStoreEnV1$PorterinFeature from "../../../../../containers/fare-estimate-v1/domain/store/FareEstimateResultStoreEnV1.mjs";

var validators_category = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var category = param.category;
      if (category === FareEstimateResultStoreEnV1$PorterinFeature.service_category_two_wheelers || category === FareEstimateResultStoreEnV1$PorterinFeature.service_category_trucks) {
        return {
                TAG: /* Ok */0,
                _0: category
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: FareEstimateResultStoreEn$PorterinFeature.form_invalid_category
              };
      }
    })
};

var validators_drop_address = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var drop_address = param.drop_address;
      if (drop_address.landmark.length > 0) {
        if (drop_address.location.lat > 0.0 && drop_address.location.lat < 1000.0) {
          return {
                  TAG: /* Ok */0,
                  _0: drop_address
                };
        } else {
          return {
                  TAG: /* Error */1,
                  _0: FareEstimateResultStoreEn$PorterinFeature.form_invalid_dropoff_location
                };
        }
      } else {
        return {
                TAG: /* Error */1,
                _0: FareEstimateResultStoreEn$PorterinFeature.form_no_dropoff_location
              };
      }
    })
};

var validators_pickup_address = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var pickup_address = param.pickup_address;
      if (pickup_address.landmark.length > 0) {
        if (pickup_address.location.lat > 0.0 && pickup_address.location.lat < 1000.0) {
          return {
                  TAG: /* Ok */0,
                  _0: pickup_address
                };
        } else {
          return {
                  TAG: /* Error */1,
                  _0: FareEstimateResultStoreEn$PorterinFeature.form_invalid_pickup_location
                };
        }
      } else {
        return {
                TAG: /* Error */1,
                _0: FareEstimateResultStoreEn$PorterinFeature.form_no_pickup_location
              };
      }
    })
};

var validators = {
  category: validators_category,
  drop_address: validators_drop_address,
  pickup_address: validators_pickup_address
};

function initialFieldsStatuses(_input) {
  return {
          category: /* Pristine */0,
          drop_address: /* Pristine */0,
          pickup_address: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            category: /* Pristine */0,
            drop_address: /* Pristine */0,
            pickup_address: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.category;
  var match_0 = match ? match._0 : Curry._1(validators.category.validate, input);
  var match$1 = fieldsStatuses.drop_address;
  var match_0$1 = match$1 ? match$1._0 : Curry._1(validators.drop_address.validate, input);
  var match$2 = fieldsStatuses.pickup_address;
  var match_0$2 = match$2 ? match$2._0 : Curry._1(validators.pickup_address.validate, input);
  var categoryResult = match_0;
  var categoryResult$1;
  if (categoryResult.TAG === /* Ok */0) {
    var drop_addressResult = match_0$1;
    if (drop_addressResult.TAG === /* Ok */0) {
      var pickup_addressResult = match_0$2;
      if (pickup_addressResult.TAG === /* Ok */0) {
        return {
                TAG: /* Valid */0,
                output: {
                  pickup_address: pickup_addressResult._0,
                  drop_address: drop_addressResult._0,
                  category: categoryResult._0
                },
                fieldsStatuses: {
                  category: /* Dirty */{
                    _0: categoryResult,
                    _1: /* Shown */0
                  },
                  drop_address: /* Dirty */{
                    _0: drop_addressResult,
                    _1: /* Shown */0
                  },
                  pickup_address: /* Dirty */{
                    _0: pickup_addressResult,
                    _1: /* Shown */0
                  }
                },
                collectionsStatuses: undefined
              };
      }
      categoryResult$1 = categoryResult;
    } else {
      categoryResult$1 = categoryResult;
    }
  } else {
    categoryResult$1 = categoryResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            category: /* Dirty */{
              _0: categoryResult$1,
              _1: /* Shown */0
            },
            drop_address: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            pickup_address: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurCategoryField */0 :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.category, validators_category, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  category: status,
                                  drop_address: init.drop_address,
                                  pickup_address: init.pickup_address
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurDrop_addressField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.drop_address, validators_drop_address, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  category: init.category,
                                  drop_address: status,
                                  pickup_address: init.pickup_address
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurPickup_addressField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.pickup_address, validators_pickup_address, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  category: init.category,
                                  drop_address: init.drop_address,
                                  pickup_address: status
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */3 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : error._0;
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              Curry._2(onSubmit, output, {
                                    notifyOnSuccess: (function (input) {
                                        Curry._1(dispatch, {
                                              TAG: /* SetSubmittedStatus */3,
                                              _0: input
                                            });
                                      }),
                                    notifyOnFailure: (function (error) {
                                        Curry._1(dispatch, {
                                              TAG: /* SetSubmissionFailedStatus */4,
                                              _0: error
                                            });
                                      }),
                                    reset: (function (param) {
                                        Curry._1(dispatch, /* Reset */6);
                                      }),
                                    dismissSubmissionResult: (function (param) {
                                        Curry._1(dispatch, /* DismissSubmissionResult */5);
                                      })
                                  });
                            })
                        };
                  break;
              case /* DismissSubmissionError */4 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */5 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */6 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateCategoryField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.category, state.submissionStatus, validators_category, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            category: status,
                                            drop_address: init.drop_address,
                                            pickup_address: init.pickup_address
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateDrop_addressField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.drop_address, state.submissionStatus, validators_drop_address, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            category: init.category,
                                            drop_address: status,
                                            pickup_address: init.pickup_address
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdatePickup_addressField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, state.fieldsStatuses.pickup_address, state.submissionStatus, validators_pickup_address, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            category: init.category,
                                            drop_address: init.drop_address,
                                            pickup_address: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */3 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                category: /* Pristine */0,
                                drop_address: /* Pristine */0,
                                pickup_address: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                category: /* Pristine */0,
                                drop_address: /* Pristine */0,
                                pickup_address: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */4 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */5 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Curry._1(map, error$2)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateCategory: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateCategoryField */0,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updateDrop_address: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateDrop_addressField */1,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updatePickup_address: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdatePickup_addressField */2,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          blurCategory: (function (param) {
              Curry._1(dispatch, /* BlurCategoryField */0);
            }),
          blurDrop_address: (function (param) {
              Curry._1(dispatch, /* BlurDrop_addressField */1);
            }),
          blurPickup_address: (function (param) {
              Curry._1(dispatch, /* BlurPickup_addressField */2);
            }),
          categoryResult: Formality.exposeFieldResult(state.fieldsStatuses.category),
          drop_addressResult: Formality.exposeFieldResult(state.fieldsStatuses.drop_address),
          pickup_addressResult: Formality.exposeFieldResult(state.fieldsStatuses.pickup_address),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.category || match.drop_address || match.pickup_address) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              Curry._1(dispatch, /* Submit */3);
            }),
          dismissSubmissionError: (function (param) {
              Curry._1(dispatch, /* DismissSubmissionError */4);
            }),
          dismissSubmissionResult: (function (param) {
              Curry._1(dispatch, /* DismissSubmissionResult */5);
            }),
          mapSubmissionError: (function (map) {
              Curry._1(dispatch, {
                    TAG: /* MapSubmissionError */5,
                    _0: map
                  });
            }),
          reset: (function (param) {
              Curry._1(dispatch, /* Reset */6);
            })
        };
}

var Form = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

export {
  Form ,
}
/* react Not a pure module */
